export enum Languages {
  de = 'de',
  en = 'en',
  it = 'it',
  fr = 'fr'
}
